import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { volumes } from '../../data/content';
export function Volumes() {
  return <section className="w-full bg-[#FBF8F3] px-5 py-14 sm:px-6 sm:py-20" data-id="element-247" data-mp="2x19w8im70ic5">
      <div className="mx-auto max-w-4xl" data-id="element-248" data-mp="2wzgpz4fhs04o">
        <p className="text-center text-[11px] font-extrabold uppercase tracking-[0.18em] text-[#17808D]" data-id="element-249" data-mp="2t07t3qp5nm4w">
          📦 Cosa troverai all’interno
        </p>
        <h2 className="mt-3 text-center font-display text-[1.9rem] font-bold leading-[1.1] tracking-[-0.01em] text-[#0E3B42] sm:text-[2.75rem]" data-id="element-250" data-mp="2o2ogswc0pjfl">
          Percorso Clinico GLP-1™
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-center text-[15px] leading-relaxed text-[#3F5F64] sm:text-base" data-id="element-251" data-mp="2eb1y6excoi2t">
          Non è l’ennesimo PDF da salvare sul computer. È un sistema pratico che
          organizza ogni decisione clinica che devi prendere quando un paziente
          inizia un trattamento con GLP-1.
        </p>
        <p className="mx-auto mt-5 max-w-xl border-t border-[#0E3B42]/10 pt-5 text-center text-[14.5px] font-semibold leading-snug text-[#0E3B42]" data-id="element-252" data-mp="335mgffivatoq">
          📘 Sei Volumi Clinici che ti accompagnano dalla prima visita fino al
          follow-up a lungo termine.
        </p>

        <ol className="mt-9 space-y-4 sm:mt-12" data-id="element-253" data-mp="2u2v0p3iylbra">
          {volumes.map(volume => <li key={volume.label} className="overflow-hidden rounded-2xl border border-[#0E3B42]/10 bg-white" data-id="element-254" data-mp="2y6t0lgg3yqle">
              <div className="flex flex-col gap-1 border-b border-[#0E3B42]/10 bg-[#0E3B42] px-5 py-4 sm:px-6" data-id="element-255" data-mp="3qvqgxe0redbi">
                <span className="text-[10.5px] font-extrabold uppercase tracking-[0.2em] text-[#7FD0DA]" data-id="element-256" data-mp="3cue255xc4hr7">
                  {volume.label}
                </span>
                <h3 className="font-display text-[1.15rem] font-bold leading-tight text-white sm:text-2xl" data-id="element-257" data-mp="21gaaw7i4t7pu">
                  {volume.title}
                </h3>
              </div>
              <div className="px-5 py-5 sm:px-6" data-id="element-258" data-mp="26dagkhb2k8gf">
                <p className="text-[14.5px] leading-relaxed text-[#3F5F64] sm:text-[15px]" data-id="element-259" data-mp="bzesoit4f41a">
                  {volume.body}
                </p>
                <p className="mt-4 flex gap-2.5 rounded-xl bg-[#EEF6F7] p-3.5 text-[14px] font-semibold leading-snug text-[#0E3B42]" data-id="element-260" data-mp="7253n49n8udz">
                  <ArrowRightIcon className="mt-0.5 h-4 w-4 shrink-0 text-[#17808D]" aria-hidden="true" data-id="element-261" data-mp="3ude9xbxivflm" />
                  <span data-id="element-262" data-mp="3pbymxebsaz0l">
                    <span className="text-[#17808D]" data-id="element-263" data-mp="3kf862os5nze4">Risultato: </span>
                    {volume.result}
                  </span>
                </p>
              </div>
            </li>)}
        </ol>

        <CTAButton className="mt-10" label="Voglio i 6 volumi clinici" subline="6 Volumi + 5 Bonus per soli €19" data-id="element-264" data-mp="3bes4jkuz32bw" />
      </div>
    </section>;
}